<template>
  <div>
    <v-btn small @click="createImageLink()" class="mb-2">Save Image</v-btn>
    <v-btn small @click="createPng()" class="mb-2">Save PNG</v-btn>

    <a v-if="download" ref="link" :href="link" :download="download">
      <v-btn small class="mb-2">Download</v-btn></a
    >

    <div ref="saveImage">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import domtoimage from "dom-to-image";
export default {
  name: "CoreSaveImage",
  props: {
    name: {
      type: String,
      default: "my-image",
    },
  },
  data() {
    return {
      download: null,
      link: null,
    };
  },
  methods: {
    createImageLink() {
      const targetDiv = this.$refs.saveImage;
      console.log("targetDiv", targetDiv);

      const self = this;
      domtoimage.toJpeg(targetDiv, { quality: 0.95 }).then(function(dataUrl) {
        self.download = `${self.name}.jpeg`;
        self.link = dataUrl;
        self.$nextTick(() => {
          const targetLink = self.$refs.link;
          targetLink.click();
        });
      });
    },
    createPng() {
      const targetDiv = this.$refs.saveImage;
      console.log("targetDiv", targetDiv);
      const self = this;
      domtoimage
        .toPng(targetDiv, {
          filter: (node) => {
            return node.tagName !== "IMG";
          },
        })
        .then((dataUrl) => {
          self.download = `${self.name}.jpeg`;
          self.link = dataUrl;
          self.$nextTick(() => {
            const targetLink = self.$refs.link;
            targetLink.click();
          });
        });
    },
  },
};
</script>
